import React from 'react';
import { invoiceStatusMeta, clientInvoiceStatusMeta } from '../../lib/financial';

// Renders an invoice status chip. Two label modes:
//   audience='admin' (default) — internal lifecycle (Draft / Sent / Partial /
//                                Paid / Void). For billing operations.
//   audience='client'           — action-oriented (Action required / Awaiting
//                                payment / Overdue / Partially paid / Paid /
//                                Voided). Requires the full invoice row so
//                                we can factor in signature + overdue state.
export default function InvoiceStatusChip({ status, invoice = null, audience = 'admin', className = '' }) {
  const meta = audience === 'client' && invoice
    ? clientInvoiceStatusMeta(invoice)
    : invoiceStatusMeta(status);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium uppercase tracking-wider border ${meta.tone} ${className}`}>
      {meta.label}
    </span>
  );
}
